import classNames from 'classnames';
import { ReactNode } from 'react';
import { EmptyFolderIcon } from '../icons';
import { Button } from './Button';
import { Tooltip } from './Tooltip';

interface EmptyListStateProps {
  title: string;
  description: string;
  isLoading: boolean;
  isSearchUsed?: boolean;
  itemsCount: number;
  classes?: {
    description?: string;
    container?: string;
    title?: string;
    image?: string;
  };
  action?: {
    disabled?: boolean;
    disabledHint?: string;
    content: ReactNode;
    onClick: () => void;
    className?: string;
  };
}

export const EmptyListState = ({
  title,
  action,
  description,
  isLoading,
  classes,
  isSearchUsed = false,
  itemsCount,
}: EmptyListStateProps) => {
  if (isLoading || itemsCount) return null;
  return (
    <div
      className={classNames(
        'flex flex-col justify-center items-center gap-6 h-full m-auto max-w-[660px] p-2',
        classes?.container,
      )}
    >
      <div
        className={classNames(
          'flex items-center justify-center w-[96px] h-[96px] bg-[#E3E3E3] rounded-full',
          classes?.image,
        )}
      >
        <img alt="no results" src={EmptyFolderIcon} />
      </div>
      <div className={classNames('text-center text-4xl text-neutral-900', classes?.title)}>
        {isSearchUsed ? 'No results found' : title}
      </div>
      <div className={classNames('text-center text-neutral-900', classes?.description)}>
        {isSearchUsed
          ? 'No results found matching your filters, try a different query'
          : description}
      </div>
      {action && (
        <Tooltip
          disabled={!action.disabled || !action.disabledHint}
          button={
            <Button
              onClick={action.onClick}
              className={action.className}
              disabled={action.disabled}
            >
              {action.content}
            </Button>
          }
        >
          {action.disabledHint}
        </Tooltip>
      )}
    </div>
  );
};
